"use strict";

module.exports = require("firmata-io")(require("./com"));

